import * as React from 'react';
import { IStatisticsItem } from 'src/types/Statistics';
import { Column } from '../../types';
import ResultTableRow from './Row';

type ResultTableProps = {
  columns: Column[];
  data: IStatisticsItem[];
};

const ResultTable = ({ columns, data }: ResultTableProps) => (
  <div className="f5 overflow-x-auto">
    <div>
      <div className="flex items-center border-b border-gray-body pb-2">
        <div className="w-56 uppercase font-semibold ml-12">Kursus</div>
        <div className="w-40 uppercase font-semibold pl-2">Arrangør</div>
        <div className="w-48 uppercase font-semibold pl-2">Tema & Emner</div>
        <div className="w-10 uppercase text-right font-semibold ml-auto pr-2">Antal</div>
      </div>
      {data.map((item) => (
        <ResultTableRow
          key={item.courseCode}
          columns={columns}
          result={item}
        />
      ))}
    </div>
  </div>
);

export default ResultTable;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/ResultTable/index.tsx